const Check = () => (
  <span className="check">✓</span>
);

export default Check;
